type HookFunction<T, R> = (..._: T[]) => R;
// Higher order function that takes a "hook" function and returns a server safe
// version. Server safe means the actual hook will not run, and instead a new
// function will be returned that returns the same type or null if not server
// data is provided. If you don't provide server data, ensure you are guarding
// against null return values.
//
// Usage:
//
// ```js
//   const Component = () => {
//     const { data, isLoading } = useServerSideSafeHook(
//       useQuery, // original hook
//       { data: serverData, isLoading: true } // server return value
//     )([], someQueryFn) // args for the original hook
//   }
// ```
export default function useServerSideSafeHook<T, R>(
  hook: HookFunction<T, R>,
  serverData?: R
): HookFunction<T, R> {
  if (typeof window === 'undefined') {
    return (..._: T[]) => serverData || null;
  } else {
    return hook;
  }
}
